export const IMAGE_ALLOWED_EXTENSIONS = ['jpg', 'jpeg', 'png', 'webp', 'gif'];
export const IMAGE_MAX_SIZE_MB = 5;
export const IMAGE_ACCEPT = IMAGE_ALLOWED_EXTENSIONS.map((ext) => `.${ext}`).join(',');

// URL pública do bucket de imagens do portal (portal-entidade), usada na pré-visualização das imagens já gravadas.
// O upload devolve a URL completa; os registros guardam só o caminho no bucket.
export const IMAGE_PREVIEW_BASE_URL: string | undefined =
    process.env.REACT_APP_PORTAL_IMAGE_BASE_URL || 'https://portal-entidade.s3.us-east-1.amazonaws.com';

export function validateImageFile(file: { name: string; size: number }): string | undefined {
    const extension = file.name.split('.').pop()?.toLowerCase() || '';
    if (!IMAGE_ALLOWED_EXTENSIONS.includes(extension)) {
        return 'Formato de imagem não suportado. Use JPG, PNG, WEBP ou GIF.';
    }
    if (file.size > IMAGE_MAX_SIZE_MB * 1024 * 1024) {
        return `A imagem deve ter no máximo ${IMAGE_MAX_SIZE_MB} MB.`;
    }
    return undefined;
}

export function buildImageUrl(fileName?: string, baseUrl: string | undefined = IMAGE_PREVIEW_BASE_URL): string | undefined {
    if (!fileName) return undefined;
    if (/^https?:\/\//i.test(fileName)) return fileName;
    if (!baseUrl) return undefined;
    // Codifica cada segmento do caminho, como a API faz ao montar a URL do upload
    const key = fileName.replace(/^\//, '').split('/').map(encodeURIComponent).join('/');
    return `${baseUrl.replace(/\/$/, '')}/${key}`;
}

export function imageDisplayName(fileName?: string): string {
    if (!fileName) return '';
    return fileName.split('/').pop() || fileName;
}
